/*
This is an "old" style react component. very basic.
TODO: we need to refactor this to be a real react component and use redux properly.
*/

import '../styles/bootstrap.scss';
import '../styles/styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, Redirect, Link, IndexRoute, useRouterHistory } from 'react-router';
import { browserHistory } from 'react-router';

import configureStore from './store/configureStore';
import DemoApp from './containers/DemoApp/DemoApp';
import * as ApplicationModeActions from './actions/ApplicationModeActions';
import * as UploadActions from './actions/UploadActions';
import * as consts from './constants';
import DemoList from './components/DemoList';
import { partialRight } from 'lodash';


let store;

function getApplicationModeQueryParameter() {
  var url = window.location.href;
  var modeParams = /mode=([^&]+)/.exec(url);
  return modeParams ? modeParams[1] : null;
}

function hasModeQueryParam() {
  var modeParam = getApplicationModeQueryParameter();
  return modeParam !== null;
}

function initialize() {
  store = configureStore();
  setApplicationModeByQueryParamIfExist();
}

function setApplicationMode(mode) {
  store.dispatch(ApplicationModeActions.setApplicationMode(mode));
}

function setApplicationModeByQueryParamIfExist() {
  var modeParam = getApplicationModeQueryParameter();
  if (modeParam) {
    store.dispatch(ApplicationModeActions.setApplicationMode(modeParam));
  }
}

function isIndexMode() {
  return store.getState().applicationMode === consts.applicationModes.INDEX;
}

function onRouteChanged() {
  if (store) {
    store.dispatch(UploadActions.resetCurrentImage());
  }
  window.scrollTo(0, 0);
}

function renderByRoutes() {

  return (
    <Router onUpdate={onRouteChanged} history={browserHistory}>
      <Route path="/">
        <IndexRoute component={DemoList} />
        <Route path={consts.applicationRoutes.DEFAULT} component={DemoApp} setApplicationMode={partialRight(setApplicationMode, consts.applicationModes.DEFAULT)} />
        <Route path={consts.applicationRoutes.Q_AUTO} component={DemoApp} setApplicationMode={partialRight(setApplicationMode, consts.applicationModes.Q_AUTO)} />
        <Route path={consts.applicationRoutes.G_AUTO} component={DemoApp} setApplicationMode={partialRight(setApplicationMode, consts.applicationModes.G_AUTO)} />
        <Route path={consts.applicationRoutes.MULTI_CDN} component={DemoApp} setApplicationMode={partialRight(setApplicationMode, consts.applicationModes.MULTI_CDN)} />
        {/* Redirect to DemoList in case of unknown URL */}
        <Redirect from="*" to="/" />
      </Route>
    </Router>
  );
}

function renderByQueryParams() {
  let result;
  if (isIndexMode()) {
    result = (<DemoList />);
  } else {
    if (process.env.NODE_ENV !== 'production') {
      const DevTools = require('./containers/DevTools').default;

      result = (
        <div>
          <DemoApp />
          <DevTools />
        </div>
      );
    } else {
      result = (
        <div>
          <DemoApp />
        </div>
      );
    }
  }
  return result;
}

function render() {
  let ComponentEl;

  if (hasModeQueryParam()) {
    ComponentEl = renderByQueryParams();
  } else {
    ComponentEl = renderByRoutes();
  }

  const rootElement = document.getElementById('app');

  ReactDOM.render(
    <Provider store={store}>
      {ComponentEl}
    </Provider>,
    rootElement
  );
}

initialize();
render();




/** WEBPACK FOOTER **
 ** ./src/js/main.js
 **/